import { EstateType, ProjectType } from '@aviv-search/types';
import { GeoTypeKey } from '../../../brands/types';
import { cleanString } from '../../cleanString';
const CITY_LEVEL_OR_ABOVE_KEYS = new Set([
    GeoTypeKey.MUNICIPALITY,
    GeoTypeKey.COUNTY,
    GeoTypeKey.PROVINCE,
    GeoTypeKey.MICRO_REGION,
    GeoTypeKey.REGION,
    GeoTypeKey.COUNTRY,
]);
const staticTargeting = [
    {
        key: 'IMMO_ADGROUP',
        value: 'IMMOBILIEN_LISTE',
    },
];
const immoArtRecord = {
    apartment: 1,
    house: 2,
    plot: 3,
    office: 4,
    trading: 5,
    storage_production: 6,
    gastronomy_hotel: 10,
    agriculture_forestry: 11,
    parking: 13,
    house_or_apartment: 100,
    project: 20,
};
const immoEstateType = {
    agriculture_forestry: 'AGRICULTURE_FORESTRY',
    apartment: 'APARTMENT',
    gastronomy_hotel: 'GASTRONOMY_HOTEL',
    house: 'HOUSE',
    office: 'OFFICE',
    parking: 'PARKING',
    plot: 'PLOT',
    storage_production: 'STORAGE_PRODUCTION',
    trading: 'TRADING',
    house_or_apartment: 'HOUSE_APARTMENT',
    project: 'PROJECT',
};
const immoDistributionType = {
    buy: 'SELL',
    rent: 'RENT',
};
const immoMk = {
    buy: 1,
    rent: 2,
};
const isBoroughOrNeighborhood = (typeKey) => typeKey === GeoTypeKey.BOROUGHS || typeKey === GeoTypeKey.NEIGHBORHOOD;
const isCityLevelOrAbove = (typeKey) => typeKey !== undefined && CITY_LEVEL_OR_ABOVE_KEYS.has(typeKey);
export const getTargetingDe = ({ props: { adsSearchModel, searchModel, geoHierarchy } }) => {
    if (!adsSearchModel)
        return [];
    const location = adsSearchModel.locations?.[0] ?? '';
    let estateTypeKey = adsSearchModel.estateType ?? '';
    if (searchModel?.estateTypes &&
        searchModel.estateTypes.includes(EstateType.HOUSE) &&
        searchModel.estateTypes.includes(EstateType.APARTMENT)) {
        estateTypeKey = 'house_or_apartment';
    }
    if (searchModel?.projectTypes && searchModel?.projectTypes.includes(ProjectType.NEW_BUILD)) {
        estateTypeKey = 'project';
    }
    return [
        ...staticTargeting,
        { key: 'IMMO_ART', value: immoArtRecord[estateTypeKey] },
        { key: 'IMMO_ESTATETYPE', value: immoEstateType[estateTypeKey] },
        { key: 'IMMO_DISTRIBUTION', value: immoDistributionType[adsSearchModel.distributionType ?? ''] },
        { key: 'IMMO_MK', value: immoMk[adsSearchModel.distributionType ?? ''] },
        {
            key: 'IMMO_ORT',
            value: isBoroughOrNeighborhood(geoHierarchy?.geoTypeKey) ? geoHierarchy?.municipality?.name : location,
        },
        {
            key: 'IMMO_ORTCLEAN',
            value: isBoroughOrNeighborhood(geoHierarchy?.geoTypeKey)
                ? cleanString(geoHierarchy?.municipality?.name)
                : cleanString(location),
        },
        {
            key: 'IMMO_STADTTEIL',
            value: isCityLevelOrAbove(geoHierarchy?.geoTypeKey) ? '' : location,
        },
    ];
};
